import { memo } from 'react';
import styled from 'styled-components';

import GameImageRenderer from '../_molecules/GameImageRenderer';
import { SlideElementImageType } from './slide.types';
const regex = /image\/.+/;

const urlMediaTypes = ['image/unsplash', 'giphy/gif', 'tenor/gif'];
const SlideElementImage = ({
  element,
  isAuthenticated,
  isDiscoverTemplate,
  isOwner,
}: {
  element: SlideElementImageType;
  isAuthenticated: boolean;
  isDiscoverTemplate: boolean;
  isOwner: boolean;
}) => {
  return (
    <SlideElementImageContainer
      $objectFit={element.imageObjectFit || 'contain'}
      $borderRadius={element.borderRadius}
    >
      {urlMediaTypes.includes(element.mediaMimetype) && (
        <img src={element.mediaUrl} alt={element.mediaAltText} />
      )}
      {/* // checks if the file mimetype is an image of different types like image/png */}
      {regex.test(element.mediaMimetype) &&
        element.mediaFileId &&
        !urlMediaTypes.includes(element.mediaMimetype) && (
          <GameImageRenderer
            brightness={element.mediaBrightness}
            fileId={element.mediaFileId}
            fileMimetype={element.mediaMimetype}
            fileAltText={element.mediaAltText}
            cropConfig={element.mediaCropConfig}
            isDiscoverTemplate={isDiscoverTemplate}
            isAuthenticated={isAuthenticated}
            isOwner={isOwner}
          />
        )}
    </SlideElementImageContainer>
  );
};

const SlideElementImageContainer = styled.div<{
  $objectFit: string;
  $borderRadius?: number;
}>`
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: ${props => props.$objectFit};
    border-radius: ${props => props.$borderRadius}%;
  }
`;
export default memo(SlideElementImage);
